import { z } from 'zod';
import {
  AdvancedFeatureSchema,
  AppTypeSchema,
  PriviligesSchema,
  RoleNoPasswordSchema,
  GetStartupSchema,
  ReadyStartupSchema,
  RecoveryInspectResponseSchema,
  GatewaysResponseSchema,
  RolesNoPasswordSchema,
  MediaKeyStaleSchema,
  StartRecordingRequestSchema,
  TranscriptEntrySchema,
  TranscriptBacklogResponseSchema,
  BanEntrySchema,
  ListBansResponseSchema,
} from '@andor/contracts';

export {
  AdvancedFeatureSchema as advancedFeatureSchema,
  AppTypeSchema as appTypeSchema,
  PriviligesSchema as privilegesApiSchema,
  GetStartupSchema as startupSchema,
  ReadyStartupSchema as readyStartupSchema,
  RecoveryInspectResponseSchema as recoveryInspectSchema,
  GatewaysResponseSchema as gatewayResultSchema,
  RoleNoPasswordSchema as getRoleResponseSchema,
  RolesNoPasswordSchema as getRolesResponseSchema,
  MediaKeyStaleSchema as mediaKeyStaleSchema,
  StartRecordingRequestSchema as startRecordingRequestSchema,
  TranscriptEntrySchema as transcriptLineSchema,
  TranscriptBacklogResponseSchema as transcriptBacklogResponseSchema,
  BanEntrySchema as banEntrySchema,
  ListBansResponseSchema as listBansResponseSchema,
};
export type {
  AdvancedFeature,
  AppType,
  DefaultRoleTransferResult,
  GetStartup as Startup,
  ReadyStartup,
  RecoveryInspectResponse as RecoveryInspect,
  BanEntry,
  ListBansResponse,
  TranscriptEntry as TranscriptLineDto,
  TranscriptBacklogResponse,
  StartRecordingRequest,
  StopRecordingRequest,
  SignInRequest as LoginRequest,
} from '@andor/contracts';
export type PrivilegesApi = z.infer<typeof PriviligesSchema>;
export type GatewayResult = z.infer<typeof GatewaysResponseSchema>;
export type GetRoleResponse = z.infer<typeof RoleNoPasswordSchema>;
export type GetRolesResponse = z.infer<typeof RolesNoPasswordSchema>;

// An unsaved role in the editor has no server id yet. Passwords stay in form state.
export const roleSchema = RoleNoPasswordSchema.extend({ id: z.string().optional() });
export type Role = z.infer<typeof roleSchema>;
export const roleWithPasswordSchema = roleSchema.extend({ password: z.string().optional() });
export type RoleWithPassword = z.infer<typeof roleWithPasswordSchema>;
export const createRoleSchema = roleSchema.extend({ password: z.string() });
export type CreateRoleRequest = z.infer<typeof createRoleSchema>;

export function neutralRole(): Role {
  return roleSchema.parse({
    id: 'unknown',
    name: 'Unknown',
    default: true,
    isMember: false,
    privileges: {},
  });
}
export type LocalPrivilege = {
  id: keyof PrivilegesApi;
  label: string;
  description: string;
  active: boolean;
  show: boolean;
};
